import "@story/story_assets/dom_extend";

document.addEventSelectorListener("click", "[data-geo-address-apply]", (event, target) => {
	event.preventDefault();

	const [street, city, zip] = JSON.parse(target.dataset.geoAddressApply);

	const form = target.closest("form");
	const container = target.closest("[data-geo-address-correction]");
	const [streetInputName, cityInputName, zipInputName] = container.dataset.geoAddressCorrection.split(",");

	form.querySelector(`[name="${streetInputName}"]`).value = street;
	form.querySelector(`[name="${cityInputName}"]`).value = city;
	form.querySelector(`[name="${zipInputName}"]`).value = zip;

	container.remove();
	form.querySelector(".geo-address-status").remove();

});